import { render, staticRenderFns } from "./SmDraftInterceptor.vue?vue&type=template&id=b9a616d2&"
import script from "./SmDraftInterceptor.vue?vue&type=script&lang=ts&"
export * from "./SmDraftInterceptor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports